import Meta from "solar/components/Meta";
import content from "components/legal/privacy.md";
import Markdown from "solar/components/Markdown";
import LayoutMarkdown from "components/layouts/LayoutMarkdown";

export default function Privacy() {
  return (
    <>
      <Meta title="Privacy policy" path="/privacy" />
      <Markdown>{content}</Markdown>
    </>
  );
}

Privacy.Layout = LayoutMarkdown;
